import {Injectable} from '@angular/core';
import {FirebaseService} from './firebase.service';
import { BehaviorSubject } from 'rxjs';
import { Logger } from './logger.service';
import moment from 'moment';
import { TBookData } from '@functions/models';

const log = new Logger('UserService')

enum EUserServiceInitStatus {
  none,
  progress,
  done,
}


@Injectable({
  providedIn: 'root'
})
export class UserService {
  private _initStatus: EUserServiceInitStatus = EUserServiceInitStatus.none;

  private _booksListSubject = new BehaviorSubject<TBookData[]>([]);

  public booksListObservable = this._booksListSubject.asObservable();

  private _booksInCartListSubject = new BehaviorSubject<TBookData[]>([]);

  public booksInCartListObservable = this._booksInCartListSubject.asObservable();

  constructor(private firebaseService: FirebaseService) {}

  get booksList(): TBookData[] {
    return this._booksListSubject.value;
  }

  set booksList(value: TBookData[]) {
    this._booksListSubject.next(value);
  }

  get booksInCartList(): TBookData[] {
    return this._booksInCartListSubject.value;
  }

  set booksInCartList(value: TBookData[]) {
    this._booksInCartListSubject.next(value);
  }

  public async init() {
    if (this._initStatus) {
      const msg = `_initStatus is ${this._initStatus}`;

      log.error(msg);
      throw new Error(msg);
    }

    this._initStatus = EUserServiceInitStatus.progress;

    this.firebaseService.userBooks$.subscribe((books) => {
      this.booksList = books;
    });

    this.booksListObservable.subscribe(books => {
      this._updateBooksInCartList(books);
    });

    this._initStatus = EUserServiceInitStatus.done;
  }

  private _updateBooksInCartList(books: TBookData[]): void {
    this.booksInCartList = books.reduce<TBookData[]>((_books, book) => {
      const { isReady, isDelete, createTimeStamp, gift } = book;

      if (!createTimeStamp || isDelete || !isReady || gift) return _books;

      const createDate = moment(book.createTimeStamp.toDate());
      const duration = moment().diff(createDate, 'hours');

      if (duration > 24) return _books;

      _books.push(book);

      return _books;
    }, []);
  }
}
